Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.SpreadMethod = module.exports.default = {
	PAD: "pad",
	REFLECT: "reflect",
	REPEAT: "repeat"
};